{
  "$id": "module://share-pool",
  "$schema": "wealthlane://schemas/domain",
  "title": "Share Pool",
  "description": "Share pool field catalog — maps to Create/Update Pool DTO",
  "type": "object",
  "properties": {
    "id": {
      "type": "string",
      "title": "ID",
      "widget": "hidden"
    },
    "poolName": {
      "type": "string",
      "title": "Pool Name",
      "widget": "text",
      "noBlank": true,
      "noDoubleSpace": true
    },
    "poolTypeId": {
      "type": "number",
      "title": "Pool Type",
      "widget": "select"
    },
    "numberOfSharesAuthorised": {
      "type": "integer",
      "title": "No. of Shares Authorized",
      "widget": "number",
      "minimum": 0,
      "maximum": 2147483647,
      "inputPrecision": 0,
      "displayPrecision": 0,
      "displayFormat": "number",
      "patternPreset": "DIGITS_WITH_COMMA"
    },
    "numberOfSharesUnAvailable": {
      "type": "integer",
      "title": "No. of Shares Unavailable",
      "widget": "number",
      "minimum": 0,
      "inputPrecision": 0,
      "displayPrecision": 0,
      "displayFormat": "number",
      "patternPreset": "DIGITS_WITH_COMMA"
    },
    "numberOfSharesAvailable": {
      "type": "integer",
      "title": "No. of Shares Available",
      "widget": "number",
      "inputPrecision": 0,
      "displayPrecision": 0,
      "displayFormat": "number",
      "default": 0
    },
    "eligibleShareClass": {
      "type": "string",
      "title": "Eligible Share Class",
      "widget": "text",
      "noBlank": true,
      "noDoubleSpace": true
    },
    "stockClassId": {
      "$ref": "module://participant#/$defs/addressCountryId",
      "title": "Stock Class",
      "adapterProps": {
        "placeholder": "Select Stock Class",
        "isClearable": true
      }
    },
    "description": {
      "type": "string",
      "title": "Description",
      "widget": "textarea",
      "maxLength": 1000,
      "adapterProps": { "rows": 5 }
    },
    "hasExternalPoolRefrence": {
      "type": "boolean",
      "title": "Has External Pool Reference",
      "widget": "checkbox",
      "default": false,
      "adapterProps": {
        "reserveLabelSpace": false
      }
    },
    "externalPoolReferenceId": {
      "$ref": "module://participant#/$defs/addressCountryId",
      "title": "External Pool Name"
    },
    "externalPoolName": {
      "type": "string",
      "title": "External Pool Name (DTO)",
      "widget": "hidden"
    },
    "isTransferAgentActive": {
      "type": "boolean",
      "title": "Transfer Agent Active",
      "widget": "hidden",
      "default": false
    }
  },
  "$defs": {
    "poolId": {
      "type": "string",
      "title": "Share Pool",
      "format": "uuid",
      "widget": "select",
      "actionId": "FETCH_SHARE_POOL_OPTIONS"
    }
  }
}
